import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';
import { 
  Character,
  CharacterCondition,
  CharacterGift,
  CharacterItem,
  Condition,
  Gift,
  PseudoItem,
  ReceivableObjectType,
} from "@dndModels";
import { ModelBase } from "@models";

import DandDAPI from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";
import DataUtilities from '@dndUtilities/data_utilities';
import { makeStyles } from "@utilities/theme_utilities";

import LoadingBox from "@components/input/LoadingBox";
import DandDButtonBox from "@dndComponents/DandDButtonBoxSimple";
import DeleteButton from "@components/input/buttons/icon_buttons/DeleteButton";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import CharConnectUtilities from '@dndUtilities/char_connect_utilities';
import FlexBox from '@components/layout/FlexBox';

interface Props {
  char: Character;
}

const api = DandDAPI.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();
const data_util = DataUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function CharacterMailInput({
  char,
}: Props) {
  // const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [reloading, setReloading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [expanded_id, setExpandedId] = useState("");
    
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '4px',
      },
    });
  });

  // const load = () => {
  //   setLoading(true);
  //   char_util.getReceivables({ char }).then(() => {
  //     char.subscription_holder.receivablesChanged();
  //     setLoading(false);
  //   });
  // }

  const { classes, cx } = useStyles();
  
  if (char.campaign) {
    const campaign = char.campaign;
    // console.log(char.receivables);
    return (
      <FlexBox direction="column">
        <FlexBox className="header centered">Mail</FlexBox>
        <FlexBox direction="row">
          {/* <FlexBox xs_expand={0}>
            <RefreshButton
              onClick={load}
            />
          </FlexBox> */}
          <FlexBox className="centered">
            { char.receivables.length > 0 && 
              <DandDButtonBox
                name="Mark All Received"
                disabled={processing || char.receivables.filter(o => o.received_dt === 0).length === 0}
                onClick={async () => {
                  setProcessing(true);
                  for (const receivable of char.receivables.filter(o => o.received_dt === 0)) {
                    const new_obj = receivable;
                    new_obj.received_dt = common_util.get_time_number();
                    char.subscription_holder.receivablesChanged();
                    await api.updateObject("receivable", new_obj);
                  }
                  setProcessing(false);
                }}
              />
            }
          </FlexBox>
          <FlexBox className="centered">
            { char.receivables.length > 0 && 
              <DeleteButton
                label="Delete All"
                disabled={processing}
                onClick={async () => {
                  setProcessing(true);
                  for (const receivable of char.receivables) {
                    const new_obj = receivable;
                    await api.deleteObject("receivable", new_obj);
                  }
                  char.receivables = [];
                  char.subscription_holder.receivablesChanged();
                  setProcessing(false);
                }}
              />
            }
          </FlexBox>
        </FlexBox>
        { loading ? 
          <FlexBox>
            <LoadingBox />
          </FlexBox>
        : char.receivables.length === 0 ?
          <FlexBox className="padded centered">
            You have no mail
          </FlexBox>
        :
          <>
            { char.receivables.map(receivable => {
              console.log(receivable);
              // console.log(campaign.characters);
              const from_char = campaign.characters.find(o => o._id === receivable.from_id);
              const from = from_char ? from_char.name : (receivable.from_id === "DM" ? "Game Master" : "Missing Character");
              
              let obj: ReceivableObjectType | undefined;
              let description = " ";
              if (receivable.items.length > 0) {
                const items = receivable.items;
                if (items.length === 1) {
                  const item = items[0];
                  obj = item.obj;
                  if (item.type === "Condition" && obj instanceof CharacterCondition) {
                    // console.log(char_util.conditions);
                    const char_cond = obj;
                    const cond = data_util.conditions.find(o => o._id === char_cond.source_id);
                    if (cond instanceof Condition) {
                      if (cond.max_level > 1) {
                        description = char_cond.level < 0 ? `Remove ${char_cond.level * -1} levels of ` : `Add ${char_cond.level} levels of `;
                      } else {
                        description = char_cond.level === -1 ? "Remove " : "Apply ";
                      }
                      description += cond.name;
                    }
                  } else if (item.type === "Gift" && obj instanceof CharacterGift) {
                    // console.log(char_util.conditions);
                    const char_gift = obj;
                    const gift = data_util.gifts.find(o => o._id === char_gift.source_id);
                    if (gift instanceof Gift) {
                      if (gift.max_level > 1) {
                        description = char_gift.level < 0 ? `Remove ${char_gift.level * -1} levels of ` : `Add ${char_gift.level} levels of `;
                      } else {
                        description = char_gift.level === -1 ? "Remove " : "Apply ";
                      }
                      description += gift.name;
                    }
                  } else if (item.type === "Item Enhancement") {
                    console.error("Item Enhancement Receivables Not Implemented");
                    debugger;
                  } else if (item.type === "Item" && obj instanceof CharacterItem) {
                    description += obj.name;
                    if (obj.count > 1) {
                      description += ` x ${obj.count}`;
                    }
                  }
                } else {
                  for (const item of items) {
                    const obj = item.obj;
                    if (obj instanceof CharacterItem) {
                      if (description.length > 0) {
                        description += ", ";
                      }
                      description += obj.name;
                      if (obj.count > 1) {
                        description += ` x ${obj.count}`;
                      }
                    }
                  }
                }
              }
              description = receivable.message + "\n" + description;
              return (
                <FlexBox key={receivable._id}>
                  <div className="padded">
                    <FlexBox direction="column" className={cx(classes.root, "padded")}>
                      <FlexBox direction="row">
                        <FlexBox className="clickable"
                          onClick={() => {
                            setExpandedId(expanded_id === receivable._id ? "": receivable._id);
                          }}>
                          From: { from }
                        </FlexBox>
                        <FlexBox className="clickable"
                          onClick={() => {
                            setExpandedId(expanded_id === receivable._id ? "": receivable._id);
                          }}>
                          <DisplayStringWithReplacements cfs={char} display_string={ description } />
                        </FlexBox>
                        <FlexBox xs_expand={0} style={{ width: "200px", float: "right" }}>
                          { receivable.items.length === 1 ? 
                            <>
                            { receivable.items[0].type === "Condition" ?
                              <DandDButtonBox
                                name="Apply"
                                disabled={processing}
                                onClick={ async () => {
                                  if (obj instanceof CharacterCondition) {
                                    const receivable_obj = obj;
                                    const acf = char.alternate_condition_features.find(o => o.original_condition_id === receivable_obj.source_id);
                                    
                                    const cond_id = acf ? acf.alternate_condition_id : receivable_obj.source_id;
                                    const condition = api.conditions.find(o => o._id === cond_id);
                                    if (condition) {
                                      // Apply the condition
                                      let char_cond = char.conditions.find(o => o.source_id === cond_id);
                                      let level = char_cond?.level??0; // char.condition_hash[cond_id]?.level??0;
                                      level = Math.max(level + obj.level, 0);
                                      if (condition.max_level > 1) {
                                        level = Math.min(condition.max_level, level);
                                      } else if (level > 1) {
                                        level = 1;
                                      }
                                      if (level === 0) {
                                        if (char_cond) {
                                          char.spirit.conditions = char.conditions.filter(o => o.source_id !== cond_id);
                                        }
                                        // delete char.condition_hash[cond_id];
                                      } else {
                                        if (!char_cond) {
                                          await api.loadObject(condition);
                                          char_cond = new CharacterCondition();
                                          await char_cond.copy_source({ char, feature_source: condition });
                                          char.conditions.push(char_cond);
                                        }
                                        char_cond.level = level;
                                        // char.condition_hash[cond_id] = { level, source_true_id: "" };
                                      }
                                      char.changed();
                                      setProcessing(true);
                                      char.subscription_holder.recalculate();
                                      setProcessing(false);
                                    }
                                    char.receivables = char.receivables.filter(o => o._id !== receivable._id);
                                    char.subscription_holder.itemsChanged();
                                    char.subscription_holder.receivablesChanged();
                                    await api.deleteObject("receivable", receivable);
                                  }
                                }}
                              />
                            : receivable.items[0].type === "Gift" ?
                              <DandDButtonBox
                                name="Apply"
                                disabled={processing}
                                onClick={ async () => {
                                  if (obj instanceof CharacterGift) {
                                    const receivable_obj = obj;
                                    debugger;
                                    // const gift = data_util.gifts.find(o => o._id === receivable_obj.source_id);
                                    // if (gift) {
                                    //   await api.loadObject(gift);
                                    //   const gift_id = gift._id;
                                    //   const char_gift = char.spirit.gifts.find(o => o.source_id === gift_id);
                                    //   if (!char_gift) {
                                    //     // Apply the gift
                                    //     const char_gift = new CharacterGift();
                                    //     await char_gift.copy_source({ char, feature_source: gift });
                                    //     char_gift.level = receivable.items[0].count;
                                    //     if (char_gift.level < 1) {
                                    //       char_gift.level = 1;
                                    //     }
                                    //     char.spirit.gifts.push(char_gift);
                                    //     char.changed();
                                    //     setProcessing(true);
                                    //     char.subscription_holder.recalculate();
                                    //     setProcessing(false);
                                    //   }
                                    // }
                                    char.receivables = char.receivables.filter(o => o._id !== receivable._id);
                                    char.subscription_holder.itemsChanged();
                                    char.subscription_holder.receivablesChanged();
                                    await api.deleteObject("receivable", receivable);
                                  }
                                }}
                              />
                            : receivable.items[0].type === "Item" &&
                              <DandDButtonBox
                                name="Add to Inventory"
                                disabled={processing}
                                onClick={ async () => {
                                  if (obj instanceof CharacterItem) {
                                    char.inventory.items.push(obj);
                                    // const pseudo_item = char_util.getPseudoItem(receivable_obj._id);
                                    // await connect_util.addItem({ char, item: pseudo_item, count: receivable_obj.count });
                                    char.receivables = char.receivables.filter(o => o._id !== receivable._id);
                                    char.subscription_holder.itemsChanged();
                                    char.subscription_holder.receivablesChanged();
                                    await api.deleteObject("receivable", receivable);
                                    char.changed();
                                  }
                                }}
                              />
                            }
                            </>
                          : receivable.items.length > 1 &&
                            <>
                              <DandDButtonBox
                                name="Add to Inventory"
                                disabled={processing}
                                onClick={ async () => {
                                  const items = receivable.items;
                                  for (const item of items) {
                                    obj = item.obj;
                                    if (obj instanceof CharacterItem) {
                                      await connect_util.connectItem(char, obj);
                                      char.inventory.items.push(obj);
                                      // const pseudo_item = obj;
                                      // await connect_util.addItem({ char, item: pseudo_item, count: item.count });
                                    }
                                  }
                                  char.receivables = char.receivables.filter(o => o._id !== receivable._id);
                                  char.subscription_holder.itemsChanged();
                                  char.subscription_holder.receivablesChanged();
                                  await api.deleteObject("receivable", receivable);
                                  char.changed();
                                }}
                              />
                            </>
                          }
                        </FlexBox>
                      </FlexBox>
                      { expanded_id === receivable._id && 
                        <>
                          <FlexBox style={{ border: "1px solid", backgroundColor: "black" }}>
                            <div className="padded">
                              <FlexBox direction="row">
                                <FlexBox className="centered" style={{ width: "50%" }}>
                                  { receivable.received_dt === 0 ?
                                    <DandDButtonBox
                                      name="Mark Received"
                                      disabled={processing}
                                      onClick={ async () => {
                                        setProcessing(true);
                                        const new_obj = receivable;
                                        new_obj.received_dt = common_util.get_time_number();
                                        char.subscription_holder.receivablesChanged();
                                        await api.updateObject("receivable", new_obj);
                                        setProcessing(false);
                                      }}
                                    />
                                  :
                                    `Received ${common_util.time_string(receivable.received_dt)}`
                                  }
                                </FlexBox>
                                <FlexBox className="centered" style={{ width: "50%" }}>
                                  <DeleteButton
                                    disabled={processing}
                                    onClick={() => {
                                      setProcessing(true);
                                      const new_obj = receivable;
                                      char.receivables = char.receivables.filter(o => o._id !== new_obj._id);
                                      char.subscription_holder.receivablesChanged();
                                      api.deleteObject("receivable", new_obj).then(() => {
                                        setProcessing(false);
                                      });
                                    }}
                                  />
                                </FlexBox>
                              </FlexBox>
                            </div>
                          </FlexBox>
                        </>
                      }
                    </FlexBox>
                  </div>
                </FlexBox>
              );
            })}
          </>
        }
      </FlexBox>
    );
  }
  return <></>;
}
